export default __webpack_public_path__ + "static/media/logo-footer.5a9c65e5.svg";